import React from 'react';
import { navigateTo } from 'gatsby-link';
import YellowButtonMB from '../../components/Buttons/YellowButtonMD';
import "./ClassPreview.css";


const ClassPreview = (props) => {
    let classImage = (image) => {
        backgroundImage: image;
    }
    return (
        <div key={props.id} className="ClassPreview" onClick={() => navigateTo(props.path)}>
            <div className="col-sm-12">
                <div className="row">
                    <div className="col-sm-6">
                        {/* <div className="ClassPreview-Img" style={classImage(props.image)} /> */}
                        <img src={props.image} className="ClassPreview-Img" />
                    </div>
                    <div className="col-sm-6">
                        <div className="ClassPreview-Content">
                            <h2 className="ClassPreview-Title">{props.title}</h2>
                            <p className="ClassPreview-Desc">{props.children.substring(0, 280)}...</p>
                            <div style={{padding: "10px 0"}}>
                                <YellowButtonMB path={props.path}>View Details &raquo;</YellowButtonMB>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ClassPreview;


// WEBPACK FOOTER //
// ./src/components/Classes/ClassPreview.js